export default "__VITE_ASSET__DhgF8dFZ__"